import { CRField } from '@smart-builder/types';
import { MainResourceActionCreators, MainResourceState } from '../resource';

export type CRGlassTypeKey = {
  glassTypeId: number;
};

export enum Scope {
  Local = 'Local',
  Shared = 'Shared',
}

export type CRGlassTypeSummaryAPI = CRGlassTypeKey & {
  glassTypeName: string;
  rowKey: number;
  state: number; // gls_id from TX_GLS_glass_state table
  specialSurface: number; // cgct constants
  inUse: boolean;
  colour3DBGR?: number;
  opacity: string; // TODO SM change to number; a BCD number between 0 and 100
  isPatterned: boolean;
  isTextured: boolean;
  isSpandrel: boolean;
  scope: Scope;
  usage: number;
};

export type CRGlassTypeSummary = Omit<CRGlassTypeSummaryAPI, 'opacity'> & {
  opacity: number;
};

export type CRGlassTypeBodyAPI = CRGlassTypeKey & {
  // represents same thing as scope in the summary but a different representation
  rowKey: number;
  isLocal: boolean;
  glassTypeNameDefault: CRField<string>;
  glassTypeName?: CRField<string>;
  inUse: CRField<boolean>;
  usage: CRField<number>;
  colour3DDefaultBGR: CRField<number>;
  colour3DSiteBGR: CRField<number>;
  opacityDefault: CRField<number>;
  opacity: CRField<number>;
  specialSurface: CRField<number>;
  coatingDefaultFace: CRField<number>; // cgfa constants
  isPatterned: CRField<boolean>;
  patternDefaultVertical: CRField<number>;
  state: CRField<number>;

  textureImageIdDefault: CRField<number>;
  textureImageSourceDefault: CRField<string>;

  textureImageIdSite: CRField<number>;
  textureImageSourceSite: CRField<string>;

  textureSizeDefault: CRField<number>;
  textureSize: CRField<number>;
  isSpandrel: CRField<boolean>;
  detailsOverridden: CRField<boolean>;
};

export type CRGlassTypeBody = CRGlassTypeBodyAPI;

export type GlassTypesLoadMultiQueryParams = {
  glassTypeName?: string;
  inUseOnly?: boolean;
};

export type GlassTypesState = MainResourceState<
  CRGlassTypeKey,
  CRGlassTypeSummary,
  CRGlassTypeBody
>;
export type GlassTypesActions = MainResourceActionCreators<
  CRGlassTypeKey,
  CRGlassTypeSummary,
  CRGlassTypeBody,
  GlassTypesLoadMultiQueryParams
>;
